import React, {Fragment, useEffect, useState} from 'react';
import RNUFormService from "../../../../services/RNUFormService";
import {CHECK_IMG} from "../../../../constants";
import NumberFormat from "react-number-format";
import Color from "color";

const Template1BUrba2 = (props) => {
    const rnuFormService = new RNUFormService()
    const [items, setItems]= useState([])
    const [items2, setItems2]= useState()
    const [items3, setItems3]= useState()
    const [items4, setItems4]= useState()
    const fetchData = rnuFormService.getData('urba')
    const fetchData2 = rnuFormService.getData('urba2')
    const fetchData3 = rnuFormService.getData('urba3')
    const fetchData4 = rnuFormService.getData('urba4')

    const refDocType1 = [
            {"name":'PADDUC', "labelle": 'Plan d\'Aménagement et de Développement Durable de la Corse'},
            {"name":'SCOT', "labelle": 'Schéma de cohérence territoriale'},
            {"name":'PLUi', "labelle": 'Plan Local d\'Urbanisme intercommunal'},
            {"name":'PLU', "labelle": 'Plan Local d\'Urbanisme'},
            {"name":'PSMV', "labelle": 'Plan de sauvegarde et de mise en valeur'},
            {"name":'CC', "labelle": 'Carte communale'},
            {"name":'RNU', "labelle": 'Renseignement national d\'urbanisme'},
        ]


    useEffect(()=>{
        (fetchData)?setItems(fetchData):null;
        //console.log("data1",fetchData);
    },[fetchData])

    useEffect(()=>{
        (fetchData2)?setItems2(_.groupBy(fetchData2, 'secteur')):null;
    },[fetchData2])

    useEffect(()=>{
        (fetchData3)?setItems3(fetchData3):null;
    },[fetchData3])

    useEffect(()=>{
        (fetchData4)?setItems4(fetchData4):null;
    },[fetchData4])

    const renderTitleDoc=(item, index, stateDoc=false, etat=null)=> {
        //console.log(item, index, stateDoc, etat);
        return (
            <tr key={index}>
                <td className={'text-left'} style={{"width": "50px"}}>{item.name} </td>
                <td className={'text-left'}>{item.labelle}</td>
                <td style={{"width": "270px", "textAlign":"right", "marginRight":"10px"}}>{
                    (etat)
                    ?etat
                     :null
                }</td>
                {
                    (stateDoc)
                        ? <td className={"ue-coche ue-text-green"} style={{"width": "40px"}}><img src={CHECK_IMG} alt="Oui" height="15"/></td>
                        : <td className={"text-center"} style={{"width": "40px"}}>-</td>
                }
            </tr>
        )
    }

    const renderItem=(item, index)=>{
        //console.log(item);
        return (
            <Fragment key={index}>
            <tr >
                <td rowSpan={item[1].length} >
                   <span className={"ue-font-weight-7"}> {item[0]}</span>
                    <br/>
                   <span style={{"fontSize":"0.7rem"}} className={"ue-libelle2"}>{item[1][0].definition}</span>
                </td>
                <td style={(item[1].length>1)?{verticalAlign: 'middle', "borderBottom":"none"}:{verticalAlign: 'middle'}} className={'text-center'}>
                    <div > {item[1][0].libelle} </div>
                </td>
                {
                    (props.formtype === 'level2' ||  props.formtype === 'level1') ?
                        <>
                            <td className={'ue-col-surface'} style={(item[1].length > 1) ? {
                                "width": "50px",
                                "borderBottom": "none"
                            } : {"width": "50px"}}>
                                <span><NumberFormat value={Math.round(item[1][0].surface)} displayType={'text'}
                                                    thousandSeparator={' '}/>m<sup>2</sup> </span>
                            </td>
                            <td className={'ue-col-percent'} style={(item[1].length > 1) ? {
                                "width": "140px",
                                "paddingLeft": "20px",
                                "borderBottom": "none"
                            } : {"width": "140px", "paddingLeft": "20px"}}>
                                <span>({Math.round(item[1][0].pourcentage * 10) / 10}%)</span>
                            </td>
                        </>
                    :null
                }
            </tr>
            {
                item[1].map((item2,index2)=>{
                    return (index2>0)?renderRow(item2, index2, index2<item[1].length-1):null;
                })
            }
            </Fragment>
        )
    };

    const renderRow=(item,index, lastRow=true)=>{
        //console.log(item);
            return (
                <tr key={index} className={'text-dark '} >
                <td className={'text-center'} style={(lastRow)?{"verticalAlign": 'middle',"borderBottom":"none"}:{"verticalAlign": 'middle'}} >
                    <div className={'ue-data-libelle2'}> {item.libelle} </div>
                </td>
                    {
                        (props.formtype === 'level2' || props.formtype === 'level1') ?
                            <Fragment>
                                <td className={'ue-col-surface'}
                                    style={(lastRow) ? {"width": "50px", "borderBottom": "none"} : {"width": "50px"}}>
                                    <span><NumberFormat value={Math.round(item.surface)} displayType={'text'}
                                                        thousandSeparator={' '}/>m<sup>2</sup> </span>
                                </td>
                                <td className={'ue-col-percent'} style={(lastRow) ? {
                                    "width": "140px",
                                    "paddingLeft": "20px",
                                    "borderBottom": "none"
                                } : {"width": "140px", "paddingLeft": "20px"}}>
                                    <span>({Math.round(item.pourcentage * 10) / 10}%)</span>
                                </td>
                            </Fragment>
                            : null
                    }
            </tr>
            )
    };



    return (
        <div className="ue-section">
            <div className="ue-section ue-section-title" style={(props.primColor)?{"backgroundColor": Color(props.primColor).alpha(0.5)}:{}}>
                <span >DOCUMENT D'URBANISME</span>
            </div>
            <p>Le territoire de la commune est soumis au document d’urbanisme coché ci-dessous :</p>

            <table className={"ue-form-table-row"} style={{"border":"none"}}>
                <thead>
                <tr className={"ue-table-row-header"}>
                    <th colSpan={3}>Documents d'urbanisme</th>
                    <th style={{"textAlign":"center", "width":"40px"}}>Impact</th>
                </tr>
                </thead>
                <tbody>
                {
                    refDocType1.map((item, index)=>{

                        let result = _.findIndex(items3, (o)=>{return o.doc == item.name })
                        let docFind = (result>=0 && items3[result].opposable==1)?true:false;
                        return renderTitleDoc(item, index, docFind, (result>=0)?items3[result].etat:'')
                    })
                }
                </tbody>
            </table>
            <br/>
            <p className={"text-center"}>
                <span className={"ue-font-weight-7"}>
                    {
                        ((props.formtype=='ru'||props.formtype=="cua"||props.formtype=="cub") && fetchData4.length>0)?
                         fetchData4[0].libelle
                        :`Ce terrain est soumis aux dispositions du ${items.typedoc} ${items.etat} le ${items.datvalid} `
                    }
                </span>
                <br/>
                    {
                        (items.datappro && (props.formtype!='ru'&& props.formtype!="cua"&& props.formtype!="cua"))
                            ? <span>{items.libelle_proc} le {items.datappro} </span>
                            :null
                    }

                <br/>
                Toutefois les dispositions des articles R. 111-3, R. 111-5 à R. 111-19 et R. 111-28 à R. 111-30 ne
                sont pas applicables dans les territoires dotés d'un plan local d'urbanisme ou d'un document d'urbanisme en tenant lieu. Les termes utilisés par le règlement
                national d'urbanisme peuvent être définis par un lexique national d'urbanisme, pris par arrêté du ministre chargé de l’urbanisme.
            </p>
            <div className={"ue-mb-3"}></div>

            <table className="ue-form-table ue-table-groupby text-dark" >
                    <thead>
                    <tr className={"ue-table-row-header"}>
                        <th>Secteur</th>
                        <th className={'text-right'} style={{"width":"50px","paddingRight":"25px"}}>Zone</th>
                        {
                            (props.formtype ==='level2' ||  props.formtype === 'level1')?
                                <th className={'text-center'} colSpan={2} >Surface</th>
                                :null
                        }
                        </tr>
                        </thead>
                        <tbody>
                        {
                            (items2)
                            ?Object.entries(items2).map((item, index)=>{
                                return(renderItem(item, index))
                            })
                            :null
                        }


                    </tbody>
            </table>
            <div className={"ue-mb-5"}></div>

        </div>
    );
};

export default Template1BUrba2

